import * as i0 from "@angular/core";
var LoaderService = /** @class */ (function () {
    function LoaderService() {
        this.isLoader = false;
    }
    LoaderService.prototype.startLoader = function () {
        this.isLoader = true;
    };
    LoaderService.prototype.stopLoader = function () {
        this.isLoader = false;
    };
    LoaderService.ngInjectableDef = i0.defineInjectable({ factory: function LoaderService_Factory() { return new LoaderService(); }, token: LoaderService, providedIn: "root" });
    return LoaderService;
}());
export { LoaderService };
